export default __webpack_public_path__ + "static/media/pdf_interiorcase.990c0542.png";